class OiOpeningHours {
    private root: HTMLElement
    private canvas: HTMLCanvasElement
    private ctx: CanvasRenderingContext2D

    constructor(root: HTMLElement) {
        console.log('OiHoursAlign: constructor')
        this.root = root
        this.canvas = document.createElement('canvas')
        const context = this.canvas.getContext('2d')
        if (!context) {
            throw new Error('OiHoursAlign: Unable to get 2D context from canvas')
        }
        this.ctx = context
        this.adjustPadding()

        window.addEventListener('resize', () => {
            this.adjustPadding()
        })
    }

    private measureTextWidth(text: string, font: string): number {
        this.ctx.font = font
        return this.ctx.measureText(text).width
    }

    private adjustPadding() {
        const selector = 'div.flex.justify-between.border-b.border-black'
        const allRows = Array.from(this.root.querySelectorAll<HTMLDivElement>(selector))
        const pipeWidths: number[] = []
        const noPipeEntries: Array<{ rowDiv: HTMLDivElement; width: number }> = []

        allRows.forEach(rowDiv => {
            const pEl = Array.from(rowDiv.children).find(el => el.tagName === 'P') as HTMLParagraphElement | undefined
            if (!pEl) return

            const rawText = pEl.textContent?.trim() ?? ''
            if (rawText.length === 0) return

            const computedStyle = window.getComputedStyle(pEl)
            const fontString = computedStyle.font
            const textWidth = this.measureTextWidth(rawText, fontString)

            if (rawText.includes('|')) {
                pipeWidths.push(textWidth)
            } else {
                noPipeEntries.push({ rowDiv, width: textWidth })
            }
        })
        if (pipeWidths.length === 0) {
            noPipeEntries.forEach(entry => {
                entry.rowDiv.style.paddingRight = ''
            })
            return
        }

        const maxPipeWidth = Math.max(...pipeWidths)

        noPipeEntries.forEach(entry => {
            const rawDiff = maxPipeWidth - entry.width
            const neededPadding = Math.ceil(rawDiff) - 2

            if (neededPadding > 0) {
                entry.rowDiv.style.paddingRight = `${neededPadding}px`
            } else {
                entry.rowDiv.style.paddingRight = ''
            }
        })
    }
}
 export default OiOpeningHours;
